"use client";

import { useUser } from "@/hooks/useUser";
import { postData } from "@/utils/helpers";

import { Button, ButtonProps } from "flowbite-react";
import { useRouter } from "next/navigation";
import { useState } from "react";

interface Props {}

export default function ManageSubscriptionButton(buttonProps: ButtonProps) {
  const router = useRouter();
  const user = useUser();
  const [isCreating, setIsCreating] = useState(false);
  const redirectToCustomerPortal = async () => {
    try {
      setIsCreating(true);
      const { url } = await postData({
        url: "/api/stripe/create-portal-link",
      });
      router.push(url);
    } catch (error) {
      if (error) return alert((error as Error).message);
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <Button
      isProcessing={isCreating}
      disabled={!user}
      onClick={redirectToCustomerPortal}
      {...buttonProps}
    >
      {buttonProps.children || "Manage Subscription"}
    </Button>
  );
}
